import {
  makeSelectAuthApiConfig,
  makeSelectResourceLoadingState,
} from 'services/api/api.selectors';
import { RequestApiDataIfNecessaryPayload } from 'services/api/api.types';
import { AppState } from 'store/types';
import { getPendingSessionsEndpoint } from './pendingSessions.config';
import { pendingSessionsResponseSchema } from './pendingSessions.types';

export function selectGetPendingSessionsApiConfig(
  reduxState: AppState,
): RequestApiDataIfNecessaryPayload {
  return {
    resourceId: getPendingSessionsEndpoint,
    requestConfig: makeSelectAuthApiConfig({
      url: getPendingSessionsEndpoint,
      method: 'GET',
    })(reduxState),
    skipDefaultServerErrorHandling: true,
    successSchemaValidator: pendingSessionsResponseSchema,
  };
}

export const selectPendingSessionsLoadState = makeSelectResourceLoadingState(
  getPendingSessionsEndpoint,
);

export function selectPendingSessions(state: AppState) {
  return state.pendingSessions;
}
